import React from 'react';
import clients from '../../assets/styles/customerList.module.scss';
import { getBtnData, deleteData } from '../../api/Api';
import { firstNameClient } from '../../Helpers/Helpers';
import EachCustomer from './eachCustomer';
import EditCustomerModal from './EditCustomerModal';
import DefaultComumMessage from '../Messages/DefaultComumMessage';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import Title from '../title';
import { doc } from 'firebase/firestore';
import { db } from '../../config-firebase/firebase';
import { updateDoc } from '../../api/FirestoreInterceptor';
import { GlobalContext } from '../../GlobalContext';

export const getCustomerName = (item) => {
  if (!item) return '';
  const rawName =
    item.name && item.name !== 'anonimo' && item.name !== 'anonymous'
      ? item.name
      : item.fantasyName || item.clientName || item.nome || item.name || '';
  return typeof rawName === 'string' ? rawName.trim() : String(rawName || '');
};

const CustomerList = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const global = React.useContext(GlobalContext);

  const [customerList, setCustomerList] = React.useState(null);
  const [customer, setCustomer] = React.useState('');
  const [selectedMonth, setSelectedMonth] = React.useState('');
  const [originalCustomerList, setOriginalCustomerList] = React.useState([]);
  const [oneClient, setOneClient] = React.useState({});
  const [showPopup, setShowPopup] = React.useState(false);
  const [editCustomerData, setEditCustomerData] = React.useState(null);
  const [showEditModal, setShowEditModal] = React.useState(false);
  const [showWarningDeletePopup, setShowWarningDeltePopup] =
    React.useState(false);
  const [excludeCustomer, setExcludeCustomer] = React.useState('');
  const [refreshData, setRefreshData] = React.useState(false);
  const [editingCredits, setEditingCredits] = React.useState({});

  const handleSelectCustomer = (item) => {
    const selectedName = getCustomerName(item) || item.name || 'Cliente';
    const userMenuObj = {
      id: item.id,
      name: selectedName,
      cpf: item.cpf || '',
      phone: item.phone || '',
    };
    localStorage.setItem('userMenu', JSON.stringify(userMenuObj));
    if (global && typeof global.setAuthorizated === 'function') {
      global.setAuthorizated(true);
    }
    navigate('/admin/requestlist');
  };

  React.useEffect(() => {
    const fetchCustomer = async () => {
      const data = await getBtnData('user');
      setCustomerList(data);
      setOriginalCustomerList(data);
    };
    fetchCustomer();
  }, []);

  React.useEffect(() => {
    const fetchCustomer = async () => {
      const data = await getBtnData('user');
      setCustomerList(data);
      setOriginalCustomerList(data);
    };
    fetchCustomer();
  }, [refreshData]);

  const deleteAnonymousCustomer = async () => {
    const data = await getBtnData('user');
    const excludeCustomer = data.filter((item) => item.name === 'anonimo');
    if (excludeCustomer.length > 0) {
      await Promise.all(
        excludeCustomer.map((item) => deleteData('user', item.id))
      );
      setRefreshData((prev) => !prev);
    }
  };

  const deleteCustomer = (item, permission) => {
    setExcludeCustomer(item);
    setShowWarningDeltePopup(true);
    if (permission && excludeCustomer.name === item.name) {
      setShowWarningDeltePopup(false);
      deleteData('user', item.id);
      setRefreshData((prev) => !prev);
    }
  };

  const applyFilters = (searchValue, monthValue) => {
    let filtered = originalCustomerList;

    if (searchValue) {
      filtered = filtered.filter((item) => {
        const clientName = getCustomerName(item).toLowerCase();
        const nameMatch = clientName.includes(searchValue);
        const cpfMatch =
          item.cpf && item.cpf.toLowerCase().includes(searchValue);
        const phoneMatch =
          item.phone && item.phone.toLowerCase().includes(searchValue);
        const birthdayMatch =
          item.birthday && item.birthday.toLowerCase().includes(searchValue);
        const emailMatch =
          item.email && item.email.toLowerCase().includes(searchValue);

        return nameMatch || cpfMatch || phoneMatch || birthdayMatch || emailMatch;
      });
    }

    if (monthValue) {
      filtered = filtered.filter((item) => {
        if (!item.birthday) return false;
        // Normaliza barras para hífens para garantir que o padrão -MM- funcione em ambos os formatos
        const normalizedBirthday = item.birthday.replace(/\//g, '-');
        return normalizedBirthday.includes(`-${monthValue}-`);
      });
    }

    setCustomerList(filtered);
  };

  const handleChange = ({ target }) => {
    const searchValue = target.value.toLowerCase();
    setCustomer(searchValue);
    applyFilters(searchValue, selectedMonth);
  };

  const handleMonthChange = ({ target }) => {
    const monthValue = target.value;
    setSelectedMonth(monthValue);
    applyFilters(customer, monthValue);
  };

  const eachCustomer = (client) => {
    setOneClient(client);
    setShowPopup(true);
  };

  const handleOpenEdit = (client) => {
    setEditCustomerData(client);
    setShowEditModal(true);
  };

  const handleCustomerSaved = (updatedCustomer) => {
    setOriginalCustomerList((prevList) =>
      prevList.map((item) =>
        item.id === updatedCustomer.id ? { ...item, ...updatedCustomer } : item
      )
    );
    setCustomerList((prevList) =>
      prevList.map((item) =>
        item.id === updatedCustomer.id ? { ...item, ...updatedCustomer } : item
      )
    );
    setRefreshData((prev) => !prev);
  };

  const handleCreditInputChange = (id, value) => {
    setEditingCredits((prev) => ({
      ...prev,
      [id]: value,
    }));
  };

  const handleCreditSave = async (item) => {
    const rawValue = editingCredits[item.id];
    if (rawValue === undefined) return;

    let newCredit = 0;
    if (rawValue !== '' && !isNaN(rawValue)) {
      newCredit = Math.max(0, parseFloat(rawValue));
      newCredit = parseFloat(newCredit.toFixed(2));
    }

    try {
      const userDocRef = doc(db, 'user', item.id);
      await updateDoc(userDocRef, { credit: newCredit });

      const updatedCustomer = { ...item, credit: newCredit };
      handleCustomerSaved(updatedCustomer);

      setEditingCredits((prev) => {
        const copy = { ...prev };
        delete copy[item.id];
        return copy;
      });
    } catch (err) {
      console.error('Erro ao salvar crédito do cliente:', err);
    }
  };

  const getDisplayName = (item) => {
    const name = getCustomerName(item);
    return firstNameClient(name) || name || 'Sem nome';
  };

  return (
    <div className={clients.customerListContainer}>
      {showPopup && (
        <EachCustomer oneClient={oneClient} setShowPopup={setShowPopup} />
      )}

      {showEditModal && (
        <EditCustomerModal
          customer={editCustomerData}
          isOpen={showEditModal}
          onClose={() => {
            setShowEditModal(false);
            setEditCustomerData(null);
          }}
          onSaved={handleCustomerSaved}
        />
      )}

      <div className={clients.searchContainer}>
        <input
          type="text"
          value={customer}
          onChange={handleChange}
          placeholder="Busque por nome, CPF ou telefone"
        />
        <select
          value={selectedMonth}
          onChange={handleMonthChange}
          className={clients.monthSelect}
        >
          <option value="">Aniversariantes do Mês</option>
          <option value="01">Janeiro</option>
          <option value="02">Fevereiro</option>
          <option value="03">Março</option>
          <option value="04">Abril</option>
          <option value="05">Maio</option>
          <option value="06">Junho</option>
          <option value="07">Julho</option>
          <option value="08">Agosto</option>
          <option value="09">Setembro</option>
          <option value="10">Outubro</option>
          <option value="11">Novembro</option>
          <option value="12">Dezembro</option>
        </select>
      </div>
      <div className={clients.headerContainer}>
        <div className={clients.helpIconContainer}>
          <a
            href="https://docs.google.com/document/d/1JO_71SmMvI_lkzAerER1YuuM_F-0Sdp6-dJrdy7E1oQ/edit?tab=t.4kp1o8aw6chf"
            target="_blank"
            rel="noopener noreferrer"
            title="Abrir documentação"
          >
            <span>?</span>
          </a>
        </div>
        <Link to="/admin/admin" className={clients.btnBack} title="Sair do Módulo">
          <svg viewBox="0 0 24 24" fill="none" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M19 12H5M12 19l-7-7 7-7"/>
          </svg>
        </Link>
        <Link to="/admin/admin">
          <Title mainTitle="Lista de Clientes" />
        </Link>
      </div>

      <div className={clients.buttonTitleContainer}>
        {customerList && customerList.length > 0 && (
          <h5>
            <span>{customerList.length}</span> Clientes
          </h5>
        )}
        <button onClick={deleteAnonymousCustomer}>Excluir Anonimos</button>
      </div>
      <table>
        <thead>
          <tr>
            <th>Nome</th>
            <th>CPF</th>
            <th>Celular</th>
            <th>Aniversário</th>
            <th>Crédito</th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody>
          {customerList &&
            customerList.length > 0 &&
            customerList.map((item, index) => (
              <tr key={item.id || index}>
                <td
                  className={clients.clickableName}
                  onClick={() => eachCustomer(item)}
                  title="Clique para ver detalhes do consumo"
                >
                  {getDisplayName(item)}
                </td>
                <td>{item.cpf || '---'}</td>
                <td>{item.phone || '---'}</td>
                <td>{item.birthday || '---'}</td>
                <td>
                  <div className={clients.creditContainer}>
                    <span className={clients.currencyPrefix}>R$</span>
                    <input
                      type="number"
                      step="0.01"
                      min="0"
                      placeholder="0,00"
                      className={clients.creditInput}
                      value={
                        editingCredits[item.id] !== undefined
                          ? editingCredits[item.id]
                          : item.credit !== undefined &&
                            item.credit !== null &&
                            item.credit !== '' &&
                            Number(item.credit) > 0
                          ? Number(item.credit).toFixed(2)
                          : ''
                      }
                      onChange={(e) =>
                        handleCreditInputChange(item.id, e.target.value)
                      }
                      onBlur={() => handleCreditSave(item)}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                          e.target.blur();
                        }
                      }}
                      title="Preencha o valor do crédito do cliente"
                    />
                  </div>
                </td>
                <td>
                  <div className={clients.actionButtons}>
                    <button
                      type="button"
                      className={clients.btnEdit}
                      onClick={() => handleOpenEdit(item)}
                      title="Editar dados do cliente"
                    >
                      Editar
                    </button>
                    <button
                      type="button"
                      className={clients.btnDelete}
                      onClick={() => deleteCustomer(item, false)}
                      title="Excluir cliente"
                    >
                      Excluir
                    </button>
                    <button
                      type="button"
                      className={clients.btnSelect}
                      onClick={() => handleSelectCustomer(item)}
                      title="Selecionar cliente e voltar para o PDV"
                    >
                      Selecionar cliente
                    </button>
                  </div>
                </td>
              </tr>
            ))}
        </tbody>
      </table>

      {showWarningDeletePopup && (
        <DefaultComumMessage
          msg={`Você está prestes a excluir ${getCustomerName(excludeCustomer) || 'este cliente'}`}
          item={excludeCustomer}
          onConfirm={deleteCustomer}
          onClose={() => setShowWarningDeltePopup(false)}
        />
      )}
    </div>
  );
};
export default CustomerList;

